import { useEffect } from 'react';

export default function useNoindex(shouldApply = true) {
  useEffect(() => {
    if (!shouldApply) return;

    const meta = document.querySelector('meta[name="robots"]');
    const originalContent = meta?.getAttribute('content');

    if (meta) {
      meta.setAttribute('content', 'noindex, nofollow');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'robots';
      newMeta.content = 'noindex, nofollow';
      document.head.appendChild(newMeta);
    }

    return () => {
      if (originalContent) {
        document.querySelector('meta[name="robots"]')?.setAttribute('content', originalContent);
      } else {
        document.querySelector('meta[name="robots"]')?.remove();
      }
    };
  }, [shouldApply]);
}